import { Component, ChangeDetectionStrategy, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'brd-header',
  imports: [MatIconModule],
  templateUrl: './header.html',
  styleUrl: './header.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Header {
  protected readonly menuToggle = output<void>();

  protected toggleMobileMenu(): void {
    this.menuToggle.emit();
  }
}
